import React from 'react'
import { useTrans } from 'hooks'
import { PaginaNode } from '@gql/graphql'
import { ListingHead, Page, RichiestaManualiForm } from 'components/organisms'
import styles from './RichiestaManualiTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
}

const RichiestaManualiTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <ListingHead pagina={pagina} />
        <div className={styles.main}>
          <RichiestaManualiForm />
        </div>
      </main>
    </Page>
  )
}

export default RichiestaManualiTemplate
